import { Component, OnInit } from '@angular/core';

import { PortalAuthService } from './portal-auth.service';
import { PortalPreviewService } from './portal-preview.service';

@Component({
	selector: 'portal-root',
	template: `
		<div class="portal-app-loading" *ngIf="!ready">
			<portal-loader></portal-loader>
		</div>

		<!-- Host isn't a registered portal: show a dedicated message, not the login. -->
		<div class="portal-unknown" *ngIf="ready && auth.unknownPortal">
			<div class="portal-unknown-card">
				<i class="wq wq-alert portal-unknown-icon"></i>
				<h1 class="portal-unknown-title">Portal not found</h1>
				<p class="portal-unknown-text">This URL is not a registered portal address. Please contact your dealer for more details.</p>
			</div>
		</div>

		<!--
			A preview that couldn't get a session. Its own screen rather than the login form: there is
			no account to sign into, and the only way back is to reopen it from WeQuote.
		-->
		<div class="portal-unknown" *ngIf="ready && !auth.unknownPortal && preview.failed">
			<div class="portal-unknown-card">
				<i class="wq wq-alert portal-unknown-icon"></i>
				<h1 class="portal-unknown-title">Preview unavailable</h1>
				<p class="portal-unknown-text">{{ preview.failureMessage }}</p>
			</div>
		</div>

		<ng-container *ngIf="ready && !auth.unknownPortal && !preview.failed">
			<!-- A cover preview is framed by the cover-image editor to show how the page will look, so
			     it carries none of the preview chrome. -->
			<portal-preview-banner *ngIf="preview.ready && !preview.coverMode"></portal-preview-banner>
			<router-outlet></router-outlet>
			<portal-edit-profile></portal-edit-profile>
		</ng-container>
	`
})
export class AppComponent implements OnInit {

	ready = false;

	constructor(
		public auth: PortalAuthService,
		public preview: PortalPreviewService
	) {}

	ngOnInit(): void {
		// Resolve session + org branding BEFORE rendering any page, so no screen
		// flashes the "Customer Portal" placeholder name — just a centered loader
		// until the org's branding is applied. ensureSession always resolves.
		//
		// A preview has already been settled by the APP_INITIALIZER in app.module.ts, which has to
		// run before the router's first navigation — see PortalPreviewService.bootstrap().
		if (this.preview.failed) { this.ready = true; return; }

		this.auth.ensureSession().then(() => this.ready = true, () => this.ready = true);
	}
}
